/**
 * Removes week-related tokens from a format string.
 */
export function removeWeekFromFormat(format: string) {
  return format.replace(/(lo|wo|w|l)+/g, '');
}
